import { createSlice } from "@reduxjs/toolkit";
import { CropInformationDefaultDataSetPest } from "../data_model/pestInfoModel/post_pest_information_model";

export const post_pests_Info = createSlice({
  name: "post_pests_information",
  initialState: {
    value: {
      status: false,
      langMap: CropInformationDefaultDataSetPest,
      defaultLangMap: CropInformationDefaultDataSetPest,
    },
  },
  reducers: {
    resetLangMap: (state, action) => {
      state.value.langMap = CropInformationDefaultDataSetPest;
    },
    //add empty language dataset
    addNewLangData: (state, action) => {
      state.value.status = true;
      const incomingPayload = action.payload;
      const newArray = [...state.value.langMap.langMap, incomingPayload];
      state.value.langMap.langMap = newArray;
    },
    //update individual items in localization array
    replaceIndex: (state, action) => {
      state.value.status = true;
      const newPayload = action.payload;
      const existingPayload = state.value.langMap.langMap;
      const newUpdateData = existingPayload.map((item) =>
        item.langCode === newPayload.langCode ? newPayload : item
      );
      state.value.langMap.langMap = newUpdateData;
    },
  },
});

export const { resetLangMap, addNewLangData, replaceIndex } =
  post_pests_Info.actions;

export default post_pests_Info.reducer;
